import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { ProjectContextService } from '@core/services/project-context.service';
import { AuthService } from '@core/services/auth.service';
import { isInternalRole } from '@core/models/user.model';
import { NO_PROJECT_ID } from '@core/models/project.model';
import { projectSelectedGuard } from '@core/guards/project-selected.guard';

export const ndeResultsProjectGuard: CanActivateFn = () => {
  const context = inject(ProjectContextService);
  const router = inject(Router);
  return context.ensureLoaded().pipe(map(projects => projects.some(project =>
    project.id === context.currentProject()?.id && project.id !== NO_PROJECT_ID && project.canAccess !== false && !project.archived,
  ) || router.createUrlTree(['/dashboard/projects'])));
};

export const dashboardAccessGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const external = !isInternalRole(auth.activeRole() ?? auth.currentUser()?.role ?? 'supplier');
  if (external && route.queryParamMap.get('module') !== 'nde-results') {
    return router.createUrlTree(['/dashboard'], { queryParams: { module: 'nde-results' } });
  }
  return external || route.queryParamMap.get('module') === 'nde-results'
    ? true
    : projectSelectedGuard(route, state);
};